import React, { Component } from 'react';
import { Switch } from 'antd';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

export default class BoolEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e) {
        this.props.source.value = e;
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    render() {

        return (
            <Switch checked={this.props.source.value} onChange={e => this.onChange(e)} >
            </Switch>
        );
    }
}

PropertyGridUtils.register("bool", (source, propertyGrid) => <BoolEditor source={source} propertyGrid={propertyGrid} />);